/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

/* 🧩 COMPONENTS */
import { InputSelect, Input, Label, Button, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewPartCommandsVariablesAcceptValues = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    document.title = "Configuração de Valor";
    const [loading, setLoading] = useState(true);
    const [parts, setParts] = useState([]);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());


    const partCommandField = useRef();
    const nameField = useRef();
    const ValueField = useRef();
    const abbreviationField = useRef();

    const partCommandValue = useRef();
    const nameValue = useRef();
    const customValue = useRef();
    const abbreviationValue = useRef();

    
    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getGroupVariable(){
            setLoading(true)
            let currentItem = await Services.current.getPartsCommandVariableAcceptValue(id);
            if(currentItem){
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getVariables(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setParts(currentItem);
        }


        getGroupVariable();
        getVariables();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(partCommandValue.current)){
            let form = new FormData();
            if(partCommandValue.current){form.append('command_variable', partCommandValue.current)}
            if(customValue.current){form.append('value', customValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            if(abbreviationValue.current){form.append('abbreviation', abbreviationValue.current)}

            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editPartCommandVariableAcceptValue(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>Configuração de Valor</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={"Variável"} aling="flex-start"/>
                            <InputSelect
                                key={'variable'}
                                name={'variable'}
                                id={'variable'}
                                placeholder={"Variável"}
                                invalidMessage = {"Variável!"}
                                options={parts}
                                value={partCommand?.command_variable}
                                innerRef={partCommandField}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => partCommandValue.current = value}>
                            </InputSelect>      
    
                            <Label text={"Nome"} aling="flex-start"/>
                            <Input
                                key={'name'}
                                name={'name'}
                                id={'name'}
                                placeholder={"Nome"}
                                invalidMessage = {"Nome inválida!"}
                                innerRef={nameField}
                                value={partCommand?.name}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => nameValue.current = value}>
                            </Input>                
                        </ContainerColumn>
    
                        <ContainerColumn>
                            <Label text={"Valor"} aling="flex-start"/>
                            <Input
                                key={'value'}
                                name={'value'}
                                id={'value'}
                                type={'Number'}
                                placeholder={"Valor"}
                                invalidMessage = {"Valor inválida!"}
                                innerRef={ValueField}
                                value={partCommand?.value}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => customValue.current = value}>
                            </Input>
    
                            <Label text={"Abreviação"} aling="flex-start"/>
                            <Input
                                key={'abbreviation'}
                                name={'abbreviation'}
                                id={'abbreviation'}
                                type={'text'}
                                placeholder={"Abreviação"}
                                invalidMessage = {"Abreviação inválida!"}
                                innerRef={abbreviationField}
                                value={partCommand?.abbreviation}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => abbreviationValue.current = value}>
                            </Input>
    
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deletePartCommandVariableAcceptValue(id);
                            navigate('/PartCommandsVariablesAcceptValues')
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewPartCommandsVariablesAcceptValues;